(() => {
  const initCadoProductPlans = () => {
    document.querySelectorAll('[data-cado-plan-open]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const targetId = link.getAttribute('href')?.replace('#', '');
        const target = targetId && document.getElementById(targetId);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // 月払い/年払いで商品自体が別なので、選択中の支払い方法に対応する商品を選ぶ。
    // data-variant-id しか持たない旧マークアップ（商品ページの静的プラン表）にも対応する。
    const getVariantId = (button, billing) => {
      const byBilling =
        billing === 'year' ? button.dataset.variantYear : button.dataset.variantMonth;
      return byBilling || button.dataset.variantId || '';
    };

    const clearError = (button) => {
      const existing = button.parentElement?.querySelector('[data-cado-cart-error]');
      if (existing) existing.remove();
    };

    const showError = (button, message) => {
      clearError(button);
      const error = document.createElement('p');
      error.className = 'cado-cart-error';
      error.setAttribute('data-cado-cart-error', '');
      error.setAttribute('role', 'status');
      error.textContent = message;
      button.insertAdjacentElement('afterend', error);
    };

    // 選択中の支払い方法で買える階層だけ有効にする
    const syncAddCartButtons = (billing) => {
      document.querySelectorAll('.cado-sbsc_item .add_cart').forEach((button) => {
        button.disabled = !getVariantId(button, billing);
      });
    };

    document.querySelectorAll('[data-billing-toggle]').forEach((toggle) => {
      const input = toggle.querySelector('[data-billing-input]');
      const labels = toggle.querySelectorAll('[data-billing-label]');
      const lists = document.querySelectorAll('.cado-sbsc_list');
      if (!input) return;

      const applyBilling = (billing) => {
        lists.forEach((list) => {
          list.dataset.billing = billing;
        });
        labels.forEach((label) => {
          label.classList.toggle('is-active', label.dataset.billingLabel === billing);
        });
        syncAddCartButtons(billing);
      };

      applyBilling(input.checked ? 'year' : 'month');

      input.addEventListener('change', () => {
        applyBilling(input.checked ? 'year' : 'month');
      });

      labels.forEach((label) => {
        label.addEventListener('click', () => {
          const billing = label.dataset.billingLabel;
          const isYear = billing === 'year';
          if (input.checked === isYear) return;
          input.checked = isYear;
          input.dispatchEvent(new Event('change'));
        });
      });
    });

    document.querySelectorAll('.cado-sbsc_item .add_cart').forEach((button) => {
      button.addEventListener('click', () => {
        const billing = button.closest('.cado-sbsc_list')?.dataset.billing === 'year' ? 'year' : 'month';
        const variantId = getVariantId(button, billing);
        if (!variantId) return;

        const sellingPlanId = billing === 'year'
          ? button.dataset.sellingPlanYear
          : button.dataset.sellingPlanMonth;

        const payload = { id: variantId, quantity: 1 };
        if (sellingPlanId) payload.selling_plan = sellingPlanId;

        button.disabled = true;
        clearError(button);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        })
          .then((response) =>
            response.json().then((data) => {
              // 在庫切れなどは 422 で返るため、理由を画面に出す
              if (!response.ok) throw new Error(data.description || data.message || 'カートに追加できませんでした。');
              window.location.href = '/cart';
            })
          )
          .catch((error) => {
            button.disabled = false;
            showError(button, error.message);
          });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCadoProductPlans, { once: true });
  } else {
    initCadoProductPlans();
  }
})();
